const PreQualifyFormFields = {
  FirstName: 'firstName',
  LastName: 'lastName',
  Email: 'email',
};

export default PreQualifyFormFields;
